<template>
	<div class="container">
		<el-card>
			<div slot="header">集中器管理</div>
			<div style="height: 100%">
				<div>
					<!-- <el-button type="primary" size="small">下载模板</el-button>
					<el-button type="primary" size="small">批量导入</el-button> -->
					<el-button type="primary" @click="addMeter" icon="el-icon-plus" size="small"
						style="background-color: #1c84c6 !important">添加</el-button>
					<el-button type="primary" @click="editCardInfo" class="el-icon-edit" size="small"
						style="background-color: #1abc9c !important">编辑</el-button>
					<el-button type="primary" icon="el-icon-delete" size="small" @click="deleteMeter"
						style="background-color: #ed5565 !important">删除</el-button>
					<el-button type="primary" class="iconfont icon-excel" size="small"
						style="background-color: #23c6c8 !important" @click="exportToExcel">导出</el-button>
				</div>
				<el-form ref="form" :model="form" label-width="80px" size="small" class="searchForm">
					<!-- <el-form-item label="集中器ID">
						<el-input v-model="queryParams.id" class="searchTag" clearable placeholder="集中器ID">
						</el-input>
					</el-form-item> -->
					<el-button type="primary" icon="el-icon-search" size="small" style="margin-left: 10px"
						@click="handleQuery">搜索</el-button>
				</el-form>
				<div class="tableStyle">
					<el-table :data="tableData" ref="nbCardInfoTable" style="width: 100%" height="90%"
						v-loading="loading" id="nbRecordTable" highlight-current-row
						@current-change="handleCurrentChange">
						<el-table-column type="index" width="50" label="序号" align="center" :index="indexMethod">
						</el-table-column>
						<el-table-column prop="ID" label="集中器ID" width="150" align="center">
						</el-table-column>
						<el-table-column prop="NAME" label="集中器名称" align="center">
						</el-table-column>
						<el-table-column prop="ADDRESS" label="集中器地址" align="center">
						</el-table-column>
						<el-table-column prop="PORT1" label="端口号" align="center">
						</el-table-column>
					</el-table>
					<div class="block">
						<el-pagination v-show="total > 0" @size-change="handleQuery" @current-change="handleQuery"
							:current-page.sync="queryParams.current" :page-sizes="[100, 200, 400, 600, 800, 1000]"
							:page-size.sync="queryParams.size" layout="total, sizes, prev, pager, next, jumper"
							:total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</el-card>
		<el-dialog :title="cardDialogTitle" :visible.sync="cardDialogVisible" width="800px">
			<el-form :model="cardForm" label-width="100px" :rules="cardFormRules">
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="集中器名称">
							<el-input v-model="cardForm.NAME" placeholder="集中器名称"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="集中器地址">
							<el-input v-model="cardForm.ADDRESS" placeholder="集中器地址"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="端口号">
							<el-input v-model="cardForm.PORT1" placeholder="端口号"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cardDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">保 存</el-button>
			</span>
		</el-dialog>
		<!-- 批量导入 -->
		<!-- <el-dialog title="批量导入" :visible.sync="importExcelDialogVid" width="1000px">
			<div>
				<el-upload class="upload" action="" :multiple="false" :show-file-list="false"
					accept="csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
					:http-request="importInExcel">
					<el-button size="small" type="primary">上传</el-button>
				</el-upload>

				<el-table :data="excelTableData" border style="width: 100%">
					<el-table-column prop="cardMsisdn" label="MSISDN串号" align="center">
					</el-table-column>
					<el-table-column prop="cardIccid" label="ICCID串号" width="100" align="center">
					</el-table-column>
					<el-table-column prop="cardType" label="NB卡类型" width="100" align="center" v-if="false">
					</el-table-column>
					<el-table-column prop="cardTypeName" label="NB卡类型" width="100" align="center">
					</el-table-column>
					<el-table-column prop="isp" label="运营商" width="100" align="center" v-if="false">
					</el-table-column>
					<el-table-column prop="ispName" label="运营商" width="100" align="center">
					</el-table-column>
					<el-table-column prop="buyTime" label="购卡时间" width="160" align="center">
					</el-table-column>
					<el-table-column prop="openTime" label="开卡时间" width="160" align="center">
					</el-table-column>
					<el-table-column prop="validTime" label="有效期" width="110" align="center">
					</el-table-column>
					<el-table-column prop="remark" label="备注" width="100" align="center">
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer">
				<el-button @click="importExcelDialogVid = false">取 消</el-button>
				<el-button type="primary" @click="batchAdd">确 定</el-button>
			</div>
		</el-dialog> -->
	</div>
</template>

<script>
	import {
		translateObjectEmptyAttributeToNull,isEmpty,
		// export_excel_file,
	} from '../../untils/func';
	// import exportTable from '../../untils/exportTable';
	// import moment from 'moment';
	import {
		selectList,
		save,
		remove,
			modify,
		// getPath,
		// load,
		// NbBatchAdd,
	} from '../../api/property/concentratorManagement';
	// import { convertExcelDateFormat } from '../../untils/getDate';
	// import {
	// 	selectDictionaryListByName
	// } from '../../api/comboboxLoad';
	// import dictionaryConstant from '../../constant/dictionaryConstant';
	// import XLSX from 'xlsx';
	import exportTable from '../../untils/exportTable';
	export default {
		data() {
			return {
				// excelTableColumnName: [
				// 	'MSISDN串号',
				// 	'ICCID串号',
				// 	'NB卡类型',
				// 	'运营商',
				// 	'购卡时间',
				// 	'开卡时间',
				// 	'有效期',
				// 	'备注',
				// ],
				// excelTableColumnProperty: [
				// 	'cardMsisdn',
				// 	'cardIccid',
				// 	'cardType',
				// 	'isp',
				// 	'buyTime',
				// 	'openTime',
				// 	'validTime',
				// 	'remark',
				// ],
				// excelTableNotEmptyColumn: [
				// 	'MSISDN串号',
				// 	'ICCID串号',
				// 	'NB卡类型',
				// 	'运营商',
				// 	'购卡时间',
				// 	'开卡时间',
				// 	'有效期',
				// ],

				// excelTableComboboxColumn: ['NB卡类型', '运营商'],
				// excelTableComboboxColumnTime: ['开卡时间', '购卡时间'],
				// excelTableComboboxColumnValues: [],

				// excelTableData: [],
				form: {},
				cardForm: {},
				cardFormRules: {},
				cardDialogVisible: false,
				cardDialogTitle: '',
				// 字典表格数据
				tableData: [],
				// 查询参数
				queryParams: {
					current: 1,
					size: 100,
				},
				// 遮罩层
				loading: true,
				total: 0,
				currentRow: null,
				currentRowData:null,
				cardTypeOptions: [],
				cardIspOptions: [],
				importExcelDialogVid: false,
			};
		},
		created() {
			this.init();
		},
		mounted() {},
		watch: {},
		methods: {
			// formatDate(row, columnName) {
			//   //日期转换
			//   var date = row[columnName.property];
			//   if (date === undefined || date === null || date === '') {
			//     return null;
			//   }
			//   //非时间格式问题  返回Invalid date
			//   let retFormat = moment(date).format('YYYY-MM-DD');
			//   if (retFormat === 'Invalid date') {
			//     return moment(date).format('YYYY-MM-DD');
			//   }
			//   return  moment(date).add(1,'days').format('YYYY-MM-DD');
			// },
			// 点击模板按钮下载文件
			// async downloadTemplate() {
			// 	let res = await getPath({
			// 		name: 'nb卡模板'
			// 	}).then();
			// 	let filePath = res.data;
			// 	if (!filePath) {
			// 		this.$message.error('模板未上传');
			// 	} else {
			// 		res = await load({
			// 			filePath: filePath
			// 		}).then();
			// 		export_excel_file(res.data, 'nb卡模板', res.headers.fileextend);
			// 		// this.msgSuccess('下载成功');
			// 	}
			// },
			// async batchAdd() {
			// 	await NbBatchAdd(this.excelTableData).then();
			// 	this.importExcelDialogVid = false;
			// 	await this.handleQuery();
			// 	this.msgSuccess('导入成功');
			// },

			// importInExcel(e) {
			// 	let file = e.file; // 文件信息

			// 	if (!file) {
			// 		// 没有文件
			// 		return false;
			// 	} else if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
			// 		// 格式根据自己需求定义
			// 		this.$message.error('上传格式不正确，请上传xls或者xlsx格式');
			// 		return false;
			// 	}

			// 	const fileReader = new FileReader();
			// 	fileReader.onload = (ev) => {
			// 		try {
			// 			const data = ev.target.result;
			// 			const workbook = XLSX.read(data, {
			// 				type: 'binary', // 以字符编码的方式解析
			// 				cellDates: true, //设为true，将天数的时间戳转为时间格式
			// 			});
			// 			const exlname = workbook.SheetNames[0]; // 取第一张表
			// 			const exl = XLSX.utils.sheet_to_json(workbook.Sheets[exlname]); // 生成json表格内容

			// 			var i = 0;
			// 			var j = 0;

			// 			//判断必填列
			// 			for (i = 0; i < exl.length; i++) {
			// 				for (let column of this.excelTableNotEmptyColumn) {
			// 					if (exl[i][column] == undefined) {
			// 						this.msgError('第' + (i + 1) + '行' + column + '列不能为空');
			// 						return;
			// 					}
			// 				}
			// 			}

			// 			//判断下拉框列数据是否合法
			// 			for (i = 0; i < exl.length; i++) {
			// 				for (j = 0; j < this.excelTableComboboxColumn.length; j++) {
			// 					var value = exl[i][this.excelTableComboboxColumn[j]];

			// 					if (value != undefined) {
			// 						var flag = false;
			// 						for (let option of this.excelTableComboboxColumnValues[j]) {
			// 							if (option.value == value) {
			// 								flag = true;
			// 								break;
			// 							}
			// 						}

			// 						if (!flag) {
			// 							this.msgError(
			// 								'第' +
			// 								(i + 1) +
			// 								'行' +
			// 								this.excelTableComboboxColumn[j] +
			// 								'列值不合法'
			// 							);
			// 							return;
			// 						}
			// 					}
			// 				}
			// 			}

			// 			//转换成table数据
			// 			for (i = 0; i < exl.length; i++) {
			// 				var rowO = {};
			// 				for (j = 0; j < this.excelTableColumnProperty.length; j++) {
			// 					flag = false;
			// 					var time_flag = false;
			// 					var k = 0;
			// 					for (k = 0; k < this.excelTableComboboxColumn.length; k++) {
			// 						if (
			// 							this.excelTableColumnName[j] ==
			// 							this.excelTableComboboxColumn[k]
			// 						) {
			// 							flag = true;
			// 							break;
			// 						}
			// 					}
			// 					for (
			// 						var t = 0; t < this.excelTableComboboxColumnTime.length; t++
			// 					) {
			// 						if (
			// 							this.excelTableColumnName[j] ==
			// 							this.excelTableComboboxColumnTime[t]
			// 						) {
			// 							time_flag = true;
			// 							break;
			// 						}
			// 					}

			// 					if (flag) {
			// 						for (var option of this.excelTableComboboxColumnValues[k]) {
			// 							if (option.value == exl[i][this.excelTableColumnName[j]]) {
			// 								rowO[this.excelTableColumnProperty[j]] = option.key;
			// 								rowO[this.excelTableColumnProperty[j] + 'Name'] =
			// 									option.value;
			// 								break;
			// 							}
			// 						}
			// 					} else {
			// 						if (time_flag) {
			// 							rowO[this.excelTableColumnProperty[j]] = moment(
			// 									exl[i][this.excelTableColumnName[j]]
			// 								)
			// 								.add(1, 'days')
			// 								.format('YYYY-MM-DD');
			// 							if (
			// 								rowO[this.excelTableColumnProperty[j]] == 'Invalid date'
			// 							) {
			// 								rowO[this.excelTableColumnProperty[j]] =
			// 									exl[i][this.excelTableColumnName[j]];
			// 							}
			// 						} else {
			// 							rowO[this.excelTableColumnProperty[j]] =
			// 								exl[i][this.excelTableColumnName[j]];
			// 						}
			// 					}
			// 				}
			// 				this.excelTableData.push(rowO);
			// 			}
			// 		} catch (e) {
			// 			console.log('出错了：：' + e);
			// 			return false;
			// 		}
			// 	};
			// 	fileReader.readAsBinaryString(file);
			// },
			async init() {
				await this.handleQuery();
			},
			async handleQuery() {
				this.loading = true;
				let param = this.queryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectList(param).then();
				this.tableData = response.data;
				// console.log(this.tableData);
				this.loading = false;
				this.cancelChoose();
			},
			cancelChoose() {
				this.$refs.nbCardInfoTable.setCurrentRow();
				this.currentRow = null;
			},
			async addMeter() {
				// 添加卡信息
				this.cardForm = {};
				this.cardDialogTitle = '添加集中器信息';
				this.cardDialogVisible = true;
			},
			async save() {
				if(isEmpty(this.cardForm.ID)){
					let param = {
						name:this.cardForm.NAME,
						address:this.cardForm.ADDRESS,
						port:this.cardForm.PORT1,
					};
					await save(param).then();
				}else{
					let param = {
						id:this.cardForm.ID,
						name:this.cardForm.NAME,
						address:this.cardForm.ADDRESS,
						port:this.cardForm.PORT1,
					};
					await modify(param).then();
				}
				await this.handleQuery();
				this.msgSuccess('保存成功');
				this.cardDialogVisible = false;
			},
			async editCardInfo() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					this.cardForm = this.currentRowData;
					this.cardDialogTitle = '编辑集中器';
					this.cardDialogVisible = true;
				}
			},
			deleteMeter() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					this.$confirm('确定要删除吗?', '警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					}).then(async () => {
						await remove(this.currentRow).then();
						await this.handleQuery();
						this.msgSuccess('删除成功');
					});
				}
			},

			// 单选表格某一行
			handleCurrentChange(val) {
				this.currentRow = val.ID;
				this.currentRowData = val;
			},

			// 导出表格
			async exportToExcel() {
				if (this.tableData.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParams.size;
					this.queryParams.size = this.total;
					this.queryParams.current = 1;
					await this.handleQuery();
					exportTable.exportExcel('nbRecordTable', '集中器信息');
					this.queryParams.size = size;
					await this.handleQuery();
				}
			},

			// // 打开批量导入对话框
			// importExcelClick() {
			// 	this.excelTableData = [];
			// 	this.importExcelDialogVid = true;
			// },
			indexMethod(index) {
				let num =
					this.queryParams.size * (this.queryParams.current - 1) + index + 1;
				return num;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	/deep/ .el-select {
		width: 100%;
	}

	/deep/ .el-input {
		width: 100%;
	}

	.searchTag {
		width: 200px;
	}

	.searchForm {
		margin-top: 15px;
		margin-bottom: 15px;

		.el-form-item {
			display: inline-block;
		}
	}

	.tableStyle {
		height: calc(100% - 80px);
		// background-color: pink;
	}

	@media screen and (max-width: 1414px) {
		.tableStyle {
			height: calc(100% - 130px);
		}
	}

	.block {
		margin-top: 10px;
	}
</style>
